<script setup lang="ts">
  import type { RouteLocationRaw } from 'vue-router'

  defineProps<{
    active?: boolean,
    to?: RouteLocationRaw,
  }>()
</script>

<template>
  <router-link
    v-if="to"
    class="border-b-2 p-2"
    :class="{ active: active, inactive: active === false }"
    :to="to">
    <slot></slot>
  </router-link>
  <button
    v-else
    type="button"
    :class="{ active: active, inactive: active === false }"
    class="border-b-2 p-2">
    <slot></slot>
  </button>
</template>

<style scoped>
  @reference "@/assets/styles/main.css";

  .active {
    @apply border-primary text-primary;
  }
  .inactive {
    @apply text-gray-400 hover:border-gray-400 hover:text-gray-600;
  }
</style>
